import React from 'react';
import StaticPageLayoutDesktop from 'layouts/static-page-layout/static-page-layout.desktop';
import { withFullHydrate } from '@ecommerce/nest-ssr/common';
import SupportedBrowsersBase from './index.base';

const SupportedBrowsersDesktop: React.FC = () => (
    <StaticPageLayoutDesktop>
        <SupportedBrowsersBase />
    </StaticPageLayoutDesktop>
);

export default withFullHydrate(SupportedBrowsersDesktop, { root: '#root' }, 'views/pages/static-pages/supported-browsers/index.desktop');
